export default theme => ({
  root: {},
  fieldError: {
    color: theme.palette.danger.main,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1)
  },
  submitError: {
    color: theme.palette.danger.main,
    alignText: "center",
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2)
  },
  avatarAndUploaderContainer: {
    display: "flex",
    flexDirection: "row"
  },
  inputContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3)
  },
  bigAvatar: {
    borderRadius: "0 !important",
    // width: "120px",
    // marginRight: "20px",
    // marginBottom: "20px",
    display: "block",
    // maxWidth: "150px",
    // maxHeight: "220px",
    width: "auto",
    height: "auto"
  },

  dataContainer: {
    display: "flex",
    flexDirection: "column",

    alignItems: "center"
  },
  dataContainerUrl: {
    display: "flex",
    flexDirection: "row",

    alignItems: "center"
  },
  desc: {
    alignSelf: "center"
  },
  urlDescription: {
    marginTop: "10px",
    marginBottom: "10px"
  },
  urlLinkDesc: {
    alignSelf: "center"
  },
});
